import { render, staticRenderFns } from "./GuardDetail.vue?vue&type=template&id=ed0de984&"
import script from "./GuardDetail.vue?vue&type=script&lang=js&"
export * from "./GuardDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports